import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { applyRTLToDocument } from "@shared/utils/rtl";

// Import consolidated translations
import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";
import arTranslations from "./locales/ar.json";

const savedLanguage = localStorage.getItem("language") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    fr: {
      translation: frTranslations,
    },
    ar: {
      translation: arTranslations,
    },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Apply RTL on language change
i18n.on("languageChanged", (lng) => {
  applyRTLToDocument(lng);
});

// Apply RTL on initial load
applyRTLToDocument(savedLanguage);

export default i18n;
